import Vue from 'vue';
import util from '../util';
import defaultDoctorAvatar from '@/assets/imgs/default-doctor-avatar.png';
import defaultUserAvator from '@/assets/imgs/default-user-avatar.png';
import { cargoStatus, cargoStyle, orderStatusEnum } from '@/assets/js/constant.js';

Vue.filter('parseDate', function(date, fmt = 'yyyy-MM-dd HH:mm:ss') {
  if (!date) {
    return date;
  }
  date = typeof date !== 'object' ? new Date(date) : date;
  var o = {
    'M+': date.getMonth() + 1, //月份
    'd+': date.getDate(), //日
    'h+': date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
    'H+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3) //季度
  };
  let week = {
    '0': '日',
    '1': '一',
    '2': '二',
    '3': '三',
    '4': '四',
    '5': '五',
    '6': '六'
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (RegExp.$1.length > 1 ? (RegExp.$1.length > 2 ? '星期' : '周') : '') + week[date.getDay() + '']
    );
  }
  if (/(S+)/.test(fmt)) {
    let ms = date.getMilliseconds();
    fmt = fmt.replace(
      RegExp.$1,
      RegExp.$1.length == 1
        ? ms
        : RegExp.$1.length == 2
        ? ('00' + ms).substr(('' + ms).length)
        : ('000' + ms).substr(('' + ms).length)
    );
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
});

Vue.filter('weekOfMonth', function(date) {
  const cnMap = {
    1: '第一周',
    2: '第二周',
    3: '第三周',
    4: '第四周',
    5: '第五周',
    6: '第六周'
  };
  return cnMap[date];
});

Vue.filter('weekTip', function(date) {
  var arr = date.split('~');
  var newArr = [];
  arr.forEach(item => {
    newArr.push(item.split('.').join('-'));
  });
  return newArr.join(' ~ ');
});

Vue.filter('price', (val, precise, limit = 0) => {
  if (!val && val !== 0) return '';
  if (Number(val) < limit) return limit;
  precise = precise === undefined ? 2 : precise;
  return (val / 100).toFixed(precise);
});
Vue.filter('parsePrice', (val, precise) => {
  precise = precise === undefined ? 2 : precise;
  return '¥' + (val / 100).toFixed(precise);
});

Vue.filter('sex', sex => {
  if (!sex) return '---';
  return sex == 1 ? '男' : '女';
});

Vue.filter('age', time => {
  var now = new Date().getFullYear();
  var year = new Date(time).getFullYear();
  return now > year ? now - year : 1;
});

Vue.filter('spliceText', (text, num) => {
  console.log('spliceText', text, num);
  var limit = num || 6;
  return text && text.length > limit ? text.slice(0, limit) + '...' : text;
});

Vue.filter('idCard', str => {
  console.log('cardId', str);
  if (!str) {
    return false;
  }
  var regex;
  if (str.length == 15) {
    regex = /^[1-9]\d{5}\d{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[01])\d{3}$/;
  } else if (str.length == 18) {
    regex = /^[1-9]\d{5}(19\d{2}|200[0-9]|201[0-8])(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[01])\d{3}[0-9Xx]$/;
  } else {
    // $.alert('身份证号码必须为15或18位');
    return false;
  }

  if (regex.test(str)) {
    if (str.length == 15) {
      return true;
    }
    var powers = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    var arr = str.split('');
    var code = arr.pop().toUpperCase();
    var sum = arr.reduce((pre, val, index) => {
      return pre + val * powers[index];
    }, 0);
    var locations = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
    if (locations[sum % 11] == code) {
      return true;
    } else {
      // $.alert('身份证校验码错误');
      return false;
    }
  } else {
    // $.alert('身份证号码格式错误');
    return false;
  }
});

Vue.filter('imgUrl', (url, type = 'doctor') => {
  const defaultAvatarMap = {
    doctor: defaultDoctorAvatar,
    user: defaultUserAvator
  };
  if (url && url.search(/^http/) > -1) {
    return url;
  } else {
    return url ? util.getImgUrl(url) : defaultAvatarMap[type] || ''; //type == 'doctor' ? defaultDoctorAvatar : defaultUserAvator;
  }
});

Vue.filter('day', str => {
  return str.split('.')[1];
});

// Vue.filter('source', (num, type) => {
//   if (!type) {
//     return false;
//   }
//   if (type == 1) {
//     return constant.sourceMap1[num];
//   } else {
//     return constant.sourceMap2[num];
//   }
// });

// Vue.filter('period', (num, type) => {
//   if (!type) {
//     return false;
//   }
//   if (type == 1) {
//     return constant.periodMap1[num];
//   } else {
//     return constant.periodMap2[num];
//   }
// });

Vue.filter('value', num => {
  if (!num) {
    return false;
  }
  return num.toFixed(1);
});

Vue.filter('msgDate', date => {
  if (!date) {
    return '';
  }
  var d = util.getDate(date);
  var nowDate = util.getDate(Date.now());
  if (d == nowDate) {
    return util.getTime(date, ':', 'hhmm');
  } else {
    var yesterday = new Date(nowDate).getTime() - 24 * 60 * 60 * 1000;
    if (d > yesterday && d < Date.now()) {
      return '昨天';
    } else {
      return util.getDate(d);
    }
  }
});

// 映射状态
Vue.filter('cargoStatus', (status, order) => {
  if (order && order.deliveryWay === 2 && status === 12) return '待取货';
  return cargoStatus[status];
});

// 映射状态对应的样式
Vue.filter('cargoStyle', status => {
  return cargoStyle[status];
});

Vue.filter('distance', distance => {
  if (distance) {
    if (distance < 0) {
      return '';
    } else if (distance > 1000) {
      return `距您${distance / 1000}km`;
    } else {
      return `距您${distance}m`;
    }
  }
  return '';
});
